module.exports = __webpack_public_path__ + "static/media/check_green_circle.46570f08.svg";